import { render } from "./RightInfo.vue?vue&type=template&id=3022f0f6&scoped=true"
import script from "./RightInfo.vue?vue&type=script&lang=js"
export * from "./RightInfo.vue?vue&type=script&lang=js"

import "./RightInfo.vue?vue&type=style&index=0&id=3022f0f6&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3022f0f6"]])

export default __exports__